import { GetAllGGNotificationCropDTO, GetAllGGNotificationCropFiltersDTO, GGNotificationCropDTO } from "./dto";
import { GGNotificationCropServiceImpl } from "./serviceImpl";

export interface GGNotificationCropService {
    CreateGGNotificationCrop(data: GGNotificationCropDTO): Promise<void>
    GetAllGGNotificationCrop(filters: GetAllGGNotificationCropFiltersDTO): Promise<GetAllGGNotificationCropDTO>
    GetGGNotificationCropById(id: string): Promise<GGNotificationCropDTO>
    DeleteGGNotificationCrop(id: string): Promise<void>
}

export function NewGGNotificationCropService(): GGNotificationCropService {
    return new GGNotificationCropServiceImpl()
}